export const blockIconsHomeBatteryHoriz075New = (
	<span className='material-symbols-outlined'>battery_horiz_075</span>
);
